import bigDecimal from "js-big-decimal";
import Web3 from "web3";
import moment from 'moment';

const domain = "http://192.168.1.5:2003/";
const bigUnit = new bigDecimal("1000000000000000000");
// localStorage.setItem("token","eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImRhdGRvYW4xMSIsIl9pZCI6InVzZXIxOTUzNDIwMDM2IiwiaWF0IjoxNzIzNjI0Mjk5LCJleHAiOjE4MTAwMjQyOTl9.bSN37LZHSNsvGWoZgS_lP2QKypiz1eEOIuFhlP2ekFQ")
const Login = async () => {
  const token = localStorage.getItem("token")
  try {
    // 
    const checkTelegram = async () => {

      if (window.Telegram && window.Telegram.WebApp) {
        const initDataUnsafe = window.Telegram.WebApp.initDataUnsafe;
        const initData = window.Telegram.WebApp.initData;
        // alert(initData);
        if (initData) {
          // alert(initData);
          console.log(`${domain}auth/login?${initData}`);
          const res = await fetch(`${domain}auth/login?${initData}`, {
            method: "GET",
          }).then((res) => res.json());


          if (res.code == 200) {
            localStorage.setItem("token", res.data.token);

          }

          return res;
        }
      } else {
        setTimeout(checkTelegram, 3000); // Kiểm tra lại sau 100ms nếu window.Telegram chưa sẵn sàng
      }
    };

    return await checkTelegram();

  } catch (err) {
    return false;
  }
};
const getUser = async () => {
  const token = localStorage.getItem("token")


  try {
    const res = await fetch(`${domain}user?token=${token}`, {
      method: "GET",
    }).then((res) => res.json());

    return res;
  } catch (err) {
    return false;
  }
};

const addRef = async (ref) => {
  if (!ref) {
    return;
  }
  const token = localStorage.getItem("token")

  try {
    const res = await fetch(`${domain}user/addRef?refBy=${ref}&token=${token}`, {
      method: "GET",
    }).then((res) => res.json());

    return res;
  } catch (err) {
    return false;
  }
};
const claim = async () => {

  const token = localStorage.getItem("token")

  try {
    const res = await fetch(`${domain}airdrop/claim?token=${token}`, {
      method: "GET",
    }).then((res) => res.json());

    return res;
  } catch (err) {
    return false;
  }
};
const userTop = async () => {

  const token = localStorage.getItem("token")

  try {
    const res = await fetch(`${domain}user/top`, {
      method: "GET",
    }).then((res) => res.json());

    return res;
  } catch (err) {
    return false;
  }
};

const mission = async (type) => {
  if (!type) {
    return;
  }
  const token = localStorage.getItem("token")

  try {
    const res = await fetch(`${domain}airdrop/mission?type=${type}&token=${token}`, {
      method: "GET",
    }).then((res) => res.json());

    return res;
  } catch (err) {
    return false;
  }
};

const tranfer = async (type, amount, username) => {
  if (!type || !amount || !username) {
    return;
  }

  let t = type == 1 ? "tea" : "point";
  const token = localStorage.getItem("token")
  // alert(amount)
  try {
    const res = await fetch(`${domain}user/tranfers?type=${t}&amount=${amount}&username=${username}&token=${token}`, {
      method: "GET",
    }).then((res) => res.json());

    return res;
  } catch (err) {
    return false;
  }
};

const history = async (type, page) => {

  const token = localStorage.getItem("token")


  // alert(amount)
  try {
    const res = await fetch(`${domain}user/history?type=${type}&page=${page}&token=${token}`, {
      method: "GET",
    }).then((res) => res.json());

    return res;
  } catch (err) {
    return false;
  }
};

const formartNameTop = (name) => {
  if (!name) {
    return ""
  }

  if (name.length < 6) {
    return name;
  }
  return name.slice(0, 6) + "---"
}

const bet = async (amount, type) => {

  const token = localStorage.getItem("token")


  // alert(amount)
  try {
    const res = await fetch(`${domain}bet/bet?amount=${amount}&type=${type}&token=${token}`, {
      method: "GET",
    }).then((res) => res.json());

    return res;
  } catch (err) {
    return false;
  }
};

const swap = async () => {

  const token = localStorage.getItem("token")


  // alert(amount)
  try {
    const res = await fetch(`${domain}lightWallet/swap?token=${token}`, {
      method: "GET",
    }).then((res) => res.json());

    return res;
  } catch (err) {
    return false;
  }
};

const withdraw = async (amount) => {

  const token = localStorage.getItem("token")


  // alert(amount)
  try {
    const res = await fetch(`${domain}lightWallet/sendOut?amount=${amount}&token=${token}`, {
      method: "GET",
    }).then((res) => res.json());

    return res;
  } catch (err) {
    return false;
  }
};


const balanceWallet = async () => {

  const token = localStorage.getItem("token")


  // alert(amount)
  try {
    const res = await fetch(`${domain}lightWallet/info?token=${token}`, {
      method: "GET",
    }).then((res) => res.json());

    return res;
  } catch (err) {
    return false;
  }
};


const backup = async () => {

  const token = localStorage.getItem("token")


  // alert(amount)
  try {
    const res = await fetch(`${domain}lightWallet/backup?token=${token}`, {
      method: "GET",
    }).then((res) => res.json());

    return res;
  } catch (err) {
    return false;
  }
};

const deposit = async (amount) => {

  const token = localStorage.getItem("token")


  // alert(amount)
  try {
    const res = await fetch(`${domain}lightWallet/sendIn?amount=${amount}&token=${token}`, {
      method: "GET",
    }).then((res) => res.json());

    return res;
  } catch (err) {
    return false;
  }
};


const getChartData = async (amount) => {

  const token = localStorage.getItem("token")


  // alert(amount)
  try {
    const res = await fetch(`${domain}chart/get-chart-data?token=${token}`, {
      method: "GET",
    }).then((res) => res.json());

    return res;
  } catch (err) {
    return false;
  }
};

const ShowBlance = (user, type) => {
  if (!user) {
    return 0
  }
  if (type == 1) {
    return user.balancePoint - user.withdrawdPoint
  }
  else {

    return user.balanceUsdt - user.withdrawdUsdt
  }

}

const getInfoBet = async () => {

  const token = localStorage.getItem("token")


  // alert(amount)
  try {
    const res = await fetch(`${domain}bet/info`, {
      method: "GET",
    }).then((res) => res.json());

    return res;
  } catch (err) {
    return false;
  }
};
const formatTimestamp = (date) => {
  const formattedDate = new Date(date);
  const year = formattedDate.getUTCFullYear();
  const month = String(formattedDate.getUTCMonth() + 1).padStart(2, '0');
  const day = String(formattedDate.getUTCDate()).padStart(2, '0');
  const hours = String(formattedDate.getUTCHours()).padStart(2, '0');
  const minutes = String(formattedDate.getUTCMinutes()).padStart(2, '0');
  const seconds = String(formattedDate.getUTCSeconds()).padStart(2, '0');

  return `${year}.${month}.${day} ${hours}:${minutes}:${seconds}`;
};


const get_tree = async (uid) => {
  const token = localStorage.getItem("token")
  try {
    const res = await fetch(`${domain}user/get-tree?token=${token}`, {
      method: "GET",
    }).then((res) => res.json());
    return res;
  } catch (err) {
    return false;
  }
};

export {
  get_tree,
  formatTimestamp,
  formartNameTop,
  Login,
  getUser,
  addRef,
  claim,
  userTop,
  mission,
  tranfer,
  history,
  bet,
  swap,
  withdraw,
  balanceWallet,
  backup,
  deposit,
  domain,
  getChartData,
  ShowBlance,
  getInfoBet,

}